<template>
  <div>
    <RfPromoDetailsInfoRow title="Style">
      <template #promodetail>
        {{ capitalize(displayType) }}
        <div class="pd-info-edit">
          <RfButton
            iconSize="16"
            icon="md:edit"
            variant="plain"
            density="compact"
            color="accent"
            size="x-small"
            :disabled="editDisabled"
            @click="showPromoDetailDialog"
          />
        </div>
      </template>
    </RfPromoDetailsInfoRow>
    <v-dialog
      v-model="showPromotionInfoDialog"
      width="370"
      contentClass="show-promo-details-actions"
      persistent
    >
      <v-card flat>
        <v-card-title class="headline">Appearance</v-card-title>
        <v-card-text style="padding-bottom: 0">
          <v-radio-group v-model="displayType" style="margin-top: 0">
            <v-radio
              v-for="opt in displayItems"
              :key="opt.value"
              :label="opt.text"
              :value="opt.value"
              :class="opt.class"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <v-btn
            size="large"
            class="cancel-btn"
            variant="outlined"
            width="100px"
            @click="closeDialog"
            >Close</v-btn
          >
          <v-btn
            size="large"
            width="200px"
            color="primary"
            variant="flat"
            @click="submitConfiguration"
          >
            <v-icon size="small" start>md:save</v-icon>Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RfPromoDetailsInfoRow from "@/components/RfPromotions/RfPromoDetailsInfoRow.vue";
import RfButton from "@/components/buttons/RfButton.vue";
import { cloneDeep } from "lodash-es";
import StringUtils from "@/utils/StringUtils";
import { useToastsStore } from "@/pinia/toastsStore";
import { usePromptStore } from "@/pinia/promptStore";
import { getAppearanceStyle } from "@/utils/promptGroupUtils";

export default {
  name: "RfPathGroupDisplay",
  components: { RfPromoDetailsInfoRow, RfButton },
  props: ["path", "pathGroupDisplay", "editDisabled"],
  setup: () => ({
    capitalize: StringUtils.capitalize,
    toastsStore: useToastsStore(),
    promptStore: usePromptStore(),
  }),
  data() {
    return {
      showPromotionInfoDialog: false,
      displayType: this.path.display_type,
    };
  },
  computed: {
    displayItems() {
      return getAppearanceStyle(this.path.device_type);
    },
  },
  methods: {
    closeDialog() {
      this.showPromotionInfoDialog = false;
    },
    showPromoDetailDialog() {
      this.showPromotionInfoDialog = true;
    },
    fillModel(model) {
      model.display_type = this.displayType;
    },
    submitConfiguration() {
      try {
        const model = cloneDeep(this.path);
        this.fillModel(model);

        this.promptStore.updatePathGroup({ appId: this.$route.params.aid, model });
        this.showPromotionInfoDialog = false;
        this.toastsStore.create({ type: "success", body: "Zone updated successfully" });
      } catch (e) {
        this.toastsStore.create({ type: "error", body: e.message });
      }
    },
  },
};
</script>
